import { useState } from "react";
import { AppsModal } from "./types";

/** This hook manages state for App modals that appear as siblings to
 *  Apps tables in the UI.
 */

export function useAppsModalStates() {
  const [currentAppModal, setCurrentAppModal] = useState<
    AppsModal | undefined
  >();

  return {
    currentAppModal,
    setCurrentAppModal,
  };
}
